module.exports = __webpack_public_path__ + "static/media/24.f2ef03d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/24.png
// module id = 1130
// module chunks = 0